<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/a1r1if/tc-custom/9781780103990.jpg?1734324616227" alt="This image is the cover for the book Dark Waters, The Milt Kovak Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dark Waters, The Milt Kovak Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>“Characters and dialogue as American as apple pie, a keep-’em-guessing plot, and laugh-aloud humor. A downright good read.” —<i>Booklist</i></b><br/>  <br/> When Oklahoma sheriff Milt Kovak wins a seven-day cruise for four to Puerto Rico, he takes his family—wife Jean and son Johnny Mac, plus Johnny Mac’s best friend, Early Rollins. It’s spring break and the ship is running over with children—and they really are running, everywhere. It’s complete chaos, but things are about to get even worse when Johnny Mac and Early are caught stealing.<br/>  <br/> The boys confess that they were put up to it by an older boy named Joshua—who is soon found dead on the top deck. And with two full days of sailing ahead—plus word of trouble back home in Prophesy County—Milt and his wife must team up with the ship’s security officer to try to find the killer . . .<br/>  <br/> “One of today’s finest mystery writers.” —Carolyn Hart<br/>  <br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Rogers Cooper
      </h2>
      
      <p class="authorDescription body article">Susan Rogers Cooper is half-Texan, half-Yankee, and now lives with her family in a small town in central Texas. She is the author of the ‘E.J. Pugh’ series and the ‘Milt Kovak’ series, amongst other books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Severn House
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?10948adf